/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Icon } from 'bold-ui'
import { useRouteMatch } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'

import { ProntuarioCard } from '../soap/aside/ProntuarioCard'
import { AtendimentoIframe } from './SistemasExternosAtendimentoView'

interface SistemasExternosAtendimentoDetailProps {
  atendimentoIframe: AtendimentoIframe
  url: string
  onRefresh: () => void
  loading: boolean
}

interface UrlParams {
  iframeId: string
}

interface LocationState {
  from?: string
}

export function SistemasExternosAtendimentoDetail(props: Readonly<SistemasExternosAtendimentoDetailProps>) {
  const {
    atendimentoIframe: { id, nome },
    url,
    onRefresh,
    loading,
  } = props
  const history = useHistory()
  const location = useLocation<LocationState>()
  const match = useRouteMatch<UrlParams>()

  const handleVoltar = () => {
    if (location.state?.from) {
      history.push(location.state.from)
      return
    }
    const parentUrl = match.url.replace(new RegExp(`/${id}$`), '')
    history.push(parentUrl)
  }

  const renderTitle = () => (
    <HFlow hSpacing={0.5} alignItems='center'>
      <Button skin='ghost' size='small' onClick={handleVoltar} title='Voltar'>
        <Icon icon='angleLeft' size={1.2} />
      </Button>
      {nome}
    </HFlow>
  )

  const renderContent = () => (
    <Button size='small' skin='ghost' style={styles.reloadButton} onClick={onRefresh} disabled={loading}>
      <Icon icon='undo' />
    </Button>
  )

  return (
    <ProntuarioCard title={renderTitle()} content={renderContent()}>
      {url && <iframe css={styles.iframe} src={url} title={nome} referrerPolicy='strict-origin' />}
    </ProntuarioCard>
  )
}

const styles = {
  reloadButton: css`
    padding: 0rem 0.5rem;
  `,
  iframe: css`
    width: 100%;
    margin: 0rem;
    padding: 0rem;
    height: max(calc(100vh - 25rem), 68rem);
    border: none;
  `,
}
